import InforDirection from "../../components/dashboard/InforDirection";
import SectionCard from "../../components/dashboard/SectionCard";
import { useTranslation } from "react-i18next";
import { PageShell } from "../../components/ui/page/PageShell";

const CustomerArea = () => {
  const { t } = useTranslation();

  return (
    <PageShell scroll>
      {/* Bandeau d'accueil */}
      <section className="shrink-0 rounded-2xl border border-slate-200 bg-white px-4 py-5 shadow-sm sm:px-6 sm:py-6">
        <p className="text-[11px] font-bold tracking-wider text-slate-400 uppercase">
          {import.meta.env.VITE_APP_TITLE}
        </p>
        <h1 className="mt-1.5 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          {t("Bienvenue sur votre espace client")}
        </h1>
        <p className="mt-1.5 max-w-2xl font-Nunito text-sm text-slate-500">
          {t("Accédez à vos services et informations en toute simplicité.")}
        </p>
      </section>

      <section>
        <h2 className="mb-2.5 px-1 text-[11px] font-bold tracking-wider text-slate-400 uppercase">
          {t("Vos services")}
        </h2>
        <SectionCard />
      </section>

      <InforDirection />
    </PageShell>
  );
};

export default CustomerArea;
